import React from 'react'

function ReferralPage() {
  return (
    <div>ReferralPage</div>
  )
}

export default ReferralPage